

<div class="modal-header">
    <h4 class="modal-title pull-left">Connections</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeThisModal();">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="form-group">
      <div class="form-group autocomplete-design">
        <label class="form-label">
          Invite principal
          <span class="star">*</span>
        </label>
       
        <mat-form-field  >
            <mat-select  
                        [(ngModel)]="inviteEmailAddress" 
                        (selectionChange)="onPrincipalSelect($event.value)" 
                        placeholder="Email" 
                        panelClass="dynamic-width" (click)="addClassToOverlayContainer()">
                        
              <mat-option>
                <ngx-mat-select-search 
                  [disableInitialFocus]="true" 
                  [hideClearSearchButton]="true" 
                  [clearSearchInput]="false"  
                  [searching]="loading" 
                  placeholderLabel="Search here.." 
                  #searchKey
                  (input)="dataServiceInput$.next(searchKey.value);"
                  noEntriesFoundLabel="Nothing found..">
                </ngx-mat-select-search>
              </mat-option>
              @for (item of dataService$ | async; track $index) {
                <mat-option [value]="item.Email">{{item.Email}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        <p class="redtext" *ngIf="(invalidEmail)">{{validationMsg}}</p>
      </div>
        <div class="form-group permissiongroup" [hidden]="true">
            <label class="form-label">Permission</label>
            <div class="form-radio">
                <div class="radio radio-inline">
                    <label>
                        <input name="strategies" [(ngModel)]="ExchangeInvites.PermissionId" [value]="2400" type="radio" checked>
                        <i class="helper"></i>Read Only
                    </label>
                </div><div class="radio radio-inline">
                    <label>
                        <input name="strategies" [(ngModel)]="ExchangeInvites.PermissionId" [value]="2401" type="radio">
                        <i class="helper"></i>Full Control
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div class="text-right">
        <button class="btn btn-lg btn-default" (click)="closeThisModal();">Cancel</button>
        <button class="btn btn-success btn-lg" (click)="onInvite();">Invite</button>
    </div>
    <ul class="connection-list">
        <li class="clearfix" *ngFor="let invitee of ExchangeInvitesList">
            <img [src]="invitee.PhotoPath !=='' ? invitee.PhotoPath  :'/../../../assets/img/default-profile-img.png'" />
            <div class="right">
                <h3>{{invitee.Name}} <span> {{invitee.Email}}</span></h3>
                <h5>Added : <span> {{invitee.Date | date :'MM/dd/yyyy'}}</span></h5>
                <label *ngIf="invitee.Status === 501">Waiting to accept</label>
            </div>
            <div class="btn-group geardropdown rightdropdown " dropdown>
                <button id="button-basic" dropdownToggle type="button" class="btn dropdown-toggle"
                        aria-controls="dropdown-basic">
                    <span class="icon-gear"></span>
                </button>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu"
                    role="menu" aria-labelledby="button-basic">
                    <li role="menuitem"><a class="dropdown-item" (click)="onRemoveInvitee(RemoveInvitee,'deletemodal',invitee.Id);">Remove</a></li>
                    <li role="menuitem"><a class="dropdown-item" (click)="onPermissionsChange(invitee.Id,Permissions.ReadOnly);" *ngIf="invitee.PermissionId !== Permissions.ReadOnly">Read Only</a></li>
                    <li role="menuitem"><a class="dropdown-item" (click)="onPermissionsChange(invitee.Id,Permissions.FullControl);" *ngIf="invitee.PermissionId !== Permissions.FullControl">Full Control</a></li>
                </ul>
            </div>
        </li>
    </ul>
</div>

<ng-template #ConfirmInvites>
    <div class="modal-body padding30">
        <div class="form-group">
            <h6 class="displayvalue">Invite {{inviteEmailAddress}} to the exchange {{'EX'+exchangeDetails.Id}}.</h6>
        </div>

        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRefinvite.hide()">Cancel</button>
            <button class="btn btn-lg btn-success" (click)="onInvite();">Invite</button>
        </div>
    </div>

</ng-template>

<ng-template #RemoveInvitee>

    <div class="modal-header">
        <h4 class="modal-title pull-left">Remove Invitee</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">

        <div class="form-group">
            <h6 class="displayvalue">Are you sure to remove this invitee ?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
            <button class="btn btn-lg btn-danger" (click)="removeInvitee(employeeIdToDelete, deleteIndex);">Remove</button>
        </div>
    </div>

</ng-template>
